import apiInstance from "../api";
import endPoints from "../endpoints";
import { delay } from "../helpers";
import manageSources from "../../mocks/manageSources.json";
// import manageSourcesMaster from "../../mocks/manageSourcesMaster.json";
import eligibilityRuleMaster from "../../mocks/eligibilityRule.json";
import eligibilityMaster from "../../mocks/eligibility.json";
import manageEligibility from "../../mocks/manageEligibility.json";
import employeeClassificationForSources from "../../mocks/employeeClassificationForSources.json";
import employeeDeferralTypes from "../../mocks/employeeDeferralTypes.json";
import addSourceAllocation from "../../mocks/addSourceAllocation.json";
import sourcesEffectiveDateHistory from "../../mocks/sourcesEffectiveDateHistory.json";
import vestingMaster from "../../mocks/vestingMaster.json";
import ForfeitureMaster from "../../mocks/forfeitureMaster.json";
// import getPlans from "../../mocks/getPlans.json";
import manageSourceEnrollment from "../../mocks/manageSourceEnrollment.json";
import manageDistributions from "../../mocks/manageDistributionsMaster.json";
import distributionSourceMaster from "../../mocks/distributionSourceMaster.json";
import loanMaster from "../../mocks/loanMaster.json";
// import TrusteeMasterInformation from "../../mocks/trusteeMaster.json";
// import CustodianMasterInformation from "../../mocks/custodianMaster.json";
// import AdvisorMasterInformation from "../../mocks/advisorMaster.json";
// import ManageTrustee from "../../mocks/manageTrustee.json";
import { transformMasterDataInfo } from "../../utils";

export const postPlanGridDetails = (payload) => {
  return apiInstance().post(`${endPoints.plan.postPlanGridView}`, payload);
};
export const getMasterPlans = (payload) => {
  return apiInstance().get(`${endPoints.plan.getMasterplans}/1`); //tenantId HardCoded
};
export const getPlanCount = () => {
  return apiInstance().get(`${endPoints.plan.getPlanCount}`);
};

export const GetplanYos = (id) => {
  return apiInstance().get(`${endPoints.planYos.getPlanYOS}/${id}`);
};
export const SavePlanYOS = (payload) => {
  return apiInstance().post(`${endPoints.planYos.SavePlanYOS}`, payload);
};
export const setPlanStatus = (planId, planStatus) => {
  var payload = { planId: planId, planStatus: planStatus };
  return apiInstance().post(`${endPoints.plan.setPlanStatus}`, payload);
};
export const getPlanDetails = (id) => {
  return apiInstance().get(`${endPoints.plan.getPlan}/${id}`);
};

export const getAdvisor = (id) => {
  return apiInstance().get(`${endPoints.plan.getAdvisor}/${id}`);
};
export const listAdvisor = (planId) => {
  return apiInstance().get(`${endPoints.plan.listAdvisor}/${planId}`);
};
export const deleteAdvisor = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteAdvisor}/${id}`);
};
export const saveAdvisor = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveAdvisor}`, payload);
};
export const saveAdvisorToPlan = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveAdvisorToPlan}`, payload);
};

export const getAllocation = (id) => {
  return apiInstance().get(`${endPoints.plan.getAllocation}/${id}`);
};
export const listAllocation = (planId) => {
  return apiInstance().get(`${endPoints.plan.listAllocation}/${planId}`);
};
export const deleteAllocation = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteAllocation}/${id}`);
};
export const saveAllocation = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveAllocation}`, payload);
};

export const getBasicPlanDetails = (id) => {
  return apiInstance().get(`${endPoints.plan.getBasicPlanDetails}/${id}`);
};
export const getReviewAndPlanDetails = (id) => {
  return apiInstance().get(`${endPoints.plan.getReviewAndPlanDetails}/${id}`);
};
export const listBasicPlanDetails = (planId) => {
  return apiInstance().get(`${endPoints.plan.listBasicPlanDetails}/${planId}`);
};
export const deletebasicplanDetails = (id) => {
  return apiInstance().delete(`${endPoints.plan.deletebasicplanDetails}/${id}`);
};
export const saveBasicPlanDetails = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveBasicPlanDetails}`, payload);
};

export const getCompensation = (id) => {
  return apiInstance().get(`${endPoints.plan.getCompensation}/${id}`);
};
export const listCompensation = (planId) => {
  return apiInstance().get(`${endPoints.plan.listCompensation}/${planId}`);
};
export const deleteCompensation = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteCompensation}/${id}`);
};
export const saveCompensation = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveCompensation}`, payload);
};

export const getCompliance = (id) => {
  return apiInstance().get(`${endPoints.plan.getCompliance}/${id}`);
};
export const listCompliance = (planId) => {
  return apiInstance().get(`${endPoints.plan.listCompliance}/${planId}`);
};
export const deleteCompliance = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteCompliance}/${id}`);
};
export const saveCompliance = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveCompliance}`, payload);
};

export const getCustodian = (id) => {
  return apiInstance().get(`${endPoints.plan.getCustodian}/${id}`);
};
export const listCustodian = (planId) => {
  return apiInstance().get(`${endPoints.plan.listCustodian}/${planId}`);
};
export const deleteCustodian = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteCustodian}/${id}`);
};
export const saveCustodian = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveCustodian}`, payload);
};

export const getEligibleRule = (id) => {
  return apiInstance().get(`${endPoints.plan.getEligibleRule}/${id}`);
};
export const listEligibleRule = (planId) => {
  return apiInstance().get(`${endPoints.plan.listEligibleRule}/${planId}`);
};
export const getPlanEligibleMasterLTPTData = () => {
  return apiInstance().get(`${endPoints.plan.getPlanEligibleMasterLTPTData}`);
};

export const deleteEligibleRule = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteEligibleRule}/${id}`);
};
export const saveEligibleRule = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveEligibleRule}`, payload);
};

export const getEnrollment = (id) => {
  return apiInstance().get(`${endPoints.plan.getEnrollment}/${id}`);
};
export const listEnrollment = (planId) => {
  return apiInstance().get(`${endPoints.plan.listEnrollment}/${planId}`);
};
export const deleteEnrollment = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteEnrollment}/${id}`);
};
export const saveEnrollment = (payload) => {
  return apiInstance().post(`${endPoints.enrollment.SaveEnrollment}`, payload);
};
export const saveEnrollmentSetting = (payload) => {
  return apiInstance().post(`${endPoints.plan.SaveEnrollmentSetting}`, payload);
};

export const getEntryDate = (id) => {
  return apiInstance().get(`${endPoints.plan.getEntryDate}/${id}`);
};
export const listEntryDate = (planId) => {
  return apiInstance().get(`${endPoints.plan.listEntryDate}/${planId}`);
};
export const deleteEntryDate = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteEntryDate}/${id}`);
};
export const saveEntryDate = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveEntryDate}`, payload);
};

export const getForfeiture = (id) => {
  return apiInstance().get(`${endPoints.plan.getForfeiture}/${id}`);
};
export const listForfeiture = (planId) => {
  return apiInstance().get(`${endPoints.plan.listForfeiture}/${planId}`);
};
export const deleteForfeiture = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteForfeiture}/${id}`);
};
export const saveForfeiture = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveForfeiture}`, payload);
};

export const getFunding = (id) => {
  return apiInstance().get(`${endPoints.plan.getFunding}/${id}`);
};
export const listFunding = (planId) => {
  return apiInstance().get(`${endPoints.plan.listFunding}/${planId}`);
};
export const deleteFunding = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteFunding}/${id}`);
};
export const saveFunding = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveFunding}`, payload);
};

export const getInvestment = (id) => {
  return apiInstance().get(`${endPoints.plan.getInvestment}/${id}`);
};
export const getMasterInvestment = (id) => {
  return apiInstance().get(`${endPoints.trade.getInvestment}/${id}`);
};
export const listInvestment = (planId) => {
  return apiInstance().get(`${endPoints.plan.listInvestment}/${planId}`);
};
export const deleteInvestment = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteInvestment}/${id}`);
};
export const saveInvestment = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveInvestment}`, payload);
};
export const addInvestmentsToPlan = (payload) => {
  return apiInstance().post(`${endPoints.plan.addInvestmentsToPlan}`, payload);
};

export const getLoan = (id) => {
  return apiInstance().get(`${endPoints.plan.getLoan}/${id}`);
};
export const listLoan = (planId) => {
  return apiInstance().get(`${endPoints.plan.listLoan}/${planId}`);
};
export const deleteLoan = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteLoan}/${id}`);
};
export const saveLoan = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveLoan}`, payload);
};

export const getRetirement = (id) => {
  return apiInstance().get(`${endPoints.plan.getRetirement}/${id}`);
};
export const listRetirement = (planId) => {
  return apiInstance().get(`${endPoints.plan.listRetirement}/${planId}`);
};
export const deleteRetirement = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteRetirement}/${id}`);
};
export const saveRetirement = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveRetirement}`, payload);
};

export const getRollOver = (id) => {
  return apiInstance().get(`${endPoints.plan.getRollover}/${id}`);
};
export const listRollOver = (planId) => {
  return apiInstance().get(`${endPoints.plan.listRollover}/${planId}`);
};
export const deleteRollOver = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteRollover}/${id}`);
};
export const saveRollOver = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveRollover}`, payload);
};

export const getSource = (id) => {
  return apiInstance().get(`${endPoints.plan.getSource}/${id}`);
};
export const listSource = (planId) => {
  return apiInstance().get(`${endPoints.plan.listSource}/${planId}`);
};
export const deleteSource = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteSource}/${id}`);
};
export const saveSource = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveSource}`, payload);
};

export const getSponsor = (id) => {
  return apiInstance().get(`${endPoints.plan.getSponsor}/${id}`);
};
export const listSponsor = (planId) => {
  return apiInstance().get(`${endPoints.plan.listSponsor}/${planId}`);
};
export const deleteSponsor = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteSponsor}/${id}`);
};
export const saveSponsor = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveSponsor}`, payload);
};

export const getTransfer = (id) => {
  return apiInstance().get(`${endPoints.plan.getTransfer}/${id}`);
};
export const listTransfer = (planId) => {
  return apiInstance().get(`${endPoints.plan.listTransfer}/${planId}`);
};
export const deleteTransfer = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteTransfer}/${id}`);
};
export const saveTransfer = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveTransfer}`, payload);
};

export const getTrustee = (id) => {
  return apiInstance().get(`${endPoints.plan.getTrustee}/${id}`);
};
export const listTrustee = (planId) => {
  return apiInstance().get(`${endPoints.plan.listTrustee}/${planId}`);
};
export const deleteTrustee = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteTrustee}/${id}`);
};
export const saveTrustee = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveTrustee}`, payload);
};
export const saveTrusteeToPlan = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveTrusteeToPlan}`, payload);
};

export const getVesting = (id) => {
  return apiInstance().get(`${endPoints.plan.getVesting}/${id}`);
};
export const listVesting = (planId) => {
  return apiInstance().get(`${endPoints.plan.listVesting}/${planId}`);
};
export const deleteVesting = (payload) => {
  return apiInstance().post(`${endPoints.plan.deleteVesting}`, payload);
};
export const deleteAdditionalVesting = (payload) => {
  return apiInstance().post(
    `${endPoints.plan.deleteAdditionalVesting}`,
    payload
  );
};
export const saveVesting = (payload) => {
  return apiInstance().post(`${endPoints.plan.saveVesting}`, payload);
};

export const getWithdrawal = (id) => {
  return apiInstance().get(`${endPoints.plan.getWithdrawal}/${id}`);
};
export const listWithdrawal = (planId) => {
  return apiInstance().get(`${endPoints.plan.listWithdrawal}/${planId}`);
};
export const deleteWithdrawal = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteWithdrawal}/${id}`);
};
export const saveWithdrawal = (payload) => {
  console.log("payload", payload);
  return apiInstance().post(`${endPoints.plan.saveWithdrawal}`, payload);
};

// Trustee
export const getTrusteeCompany = (id = 1) => {
  return apiInstance()
    .get(`${endPoints.masterData.getTrustees}/${id}`)
    .then((response) => transformMasterDataInfo(response));
};

// Trustee
export const getAdvisorCompany = (id = 1) => {
  return apiInstance()
    .get(`${endPoints.masterData.getAdvisors}/${id}`)
    .then((response) => transformMasterDataInfo(response));
};
// export const getManageTrusteeCompany = (id) => {
//   return apiInstance().get(`${endPoints.plan.getPlan}`)
//   .then((response) => {
//         return transformMasterDataInfo(response.trustees || []);
//       })
//   // return delay(1000).then(() => {
//   //   return ManageTrustee;
//   // });
// };

// Custodian
export const getIRSLimits = (planId) => {
  return apiInstance().get(`${endPoints.plan.getIRSLimits}/${planId}`);
};
export const getCustodianCompany = (id = 1) => {
  return apiInstance()
    .get(`${endPoints.masterData.getCustodians}/${id}`)
    .then((response) => transformMasterDataInfo(response));
};

export const getPlanCompanyNameExists = (planName) => {
  return apiInstance().get(`${endPoints.plan.checkPlanNameExists}/${planName}`);
};

export const checkRkPlanNumberExists = (rkPlanNumber) => {
  return apiInstance().get(
    `${endPoints.plan.checkRkPlanNumberExists}/${rkPlanNumber}`
  );
};

// Sources
export const getPlanSources = () => {
  return delay(1000).then(() => {
    return manageSources;
  });
};

export const getPlanSourcesMasterData = (id = 1) => {
  return apiInstance().get(`${endPoints.masterData.getSources}/${id}`);
};

export const getInvestmentsMasterData = (id = 1) => {
  return apiInstance().get(`${endPoints.masterData.getInvestments}/${id}`);
};

export const getEmployeeEmployeeDeferrals = () => {
  return delay(1000).then(() => {
    return employeeDeferralTypes;
  });
};

//Eligibility
export const getPlanEligibilityRuleMasterData = () => {
  return delay(1000).then(() => {
    return eligibilityRuleMaster;
  });
};

export const getPlanEligibilityMasterData = () => {
  return delay(1000).then(() => {
    return eligibilityMaster;
  });
};

export const getEmployeeClassificationForSources = () => {
  return delay(1000).then(() => {
    return employeeClassificationForSources;
  });
};

export const getPlanEligibility = () => {
  return delay(1000).then(() => {
    return manageEligibility;
  });
};

//Allocation
export const getAllocationPlanInvestmentMasterData = () => {
  return delay(1000).then(() => {
    return addSourceAllocation;
  });
};

//Vesting
export const getPlanVesting = () => {
  return delay(1000).then(() => {
    return vestingMaster;
  });
};

export const getSourcesHistory = () => {
  return delay(1000).then(() => {
    return sourcesEffectiveDateHistory;
  });
};

//Forfeiture
export const getForfeitureMaster = () => {
  return delay(1000).then(() => {
    return ForfeitureMaster;
  });
};

//Enrollment
export const getSourceEnrollment = () => {
  return delay(1000).then(() => {
    return manageSourceEnrollment;
  });
};
// export const getPlanSource=(planId)=>{
//   return apiInstance().get(`${endPoints.enrollment.getPlanSources}/${planId}`);
// }

//Distributions
export const getPlanDistributions = () => {
  return delay(1000).then(() => {
    return manageDistributions;
  });
};

export const getPlanDistributionSourceData = () => {
  return delay(1000).then(() => {
    return distributionSourceMaster;
  });
};

//Loan
export const getPlanLoan = () => {
  return delay(1000).then(() => {
    return loanMaster;
  });
};

export const getPlanSponsoringOrganisationList = () => {
  return apiInstance().get(`${endPoints.plan.getSponsoringOrganisationList}`);
};

export const postPlanSponsoringOrganisationList = (payload) => {
  return apiInstance()
    .post(`${endPoints.plan.postSponsoringOrganisationList}`, payload)
    .then(() => getPlanSponsoringOrganisationList());
};

export const postPlanDetails = (payload) => {
  return apiInstance().post(`${endPoints.plan.postPlan}`, payload);
};

export const getEmployeeClassifications = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getEmployeeClassifications}/${id}`
  );
};

export const getEmploymentStatusList = (companyId) => {
  return apiInstance().get(
    `${endPoints.plan.getEmploymentStatusList}/${companyId}`
  );
};

export const getClassificationCodes = (companyId) => {
  return apiInstance().get(
    `${endPoints.plan.getClassificationCodes}/${companyId}`
  );
};

export const getPlanCompensationCategories = (companyId) => {
  return apiInstance().get(
    `${endPoints.plan.getCompensationCategories}/${companyId}`
  );
};

export const getEmployerSourcesList = (planId) => {
  return apiInstance().get(
    `${endPoints.plan.getEmployerSourcesList}/${planId}`
  );
};

export const getEmployerSourceListForNonPayPeriod = (planId) => {
  return apiInstance().get(
    `${endPoints.plan.getEmployerSourceListForNonPayPeriod}/${planId}`
  );
};

export const getVestingRulesList = (planId) => {
  return apiInstance().get(`${endPoints.plan.getVestingRulesList}/${planId}`);
};

export const getAdoptingEmployerPlan = (id) => {
  return apiInstance().get(`${endPoints.plan.getAdoptingEmployerPlan}/${id}`);
};

export const getPlanInvestmentData = (investmentId) => {
  return apiInstance().get(
    `${endPoints.plan.getPlanInvestmentData}/${investmentId}`
  );
};
export const savePlanEligibilty = (payload) => {
  return apiInstance().post(`${endPoints.plan.savePlanEligibility}`, payload);
};
export const getPlanEligibilty = (payload) => {
  return apiInstance().get(
    `${endPoints.plan.getPlanEligibility}/${payload.eligibilityId}/${payload.amendmentId}`
  );
};
export const deletePlanEligibilty = (id, amendmentId) => {
  return apiInstance().delete(
    `${endPoints.plan.deletePlanEligibility}/${id}/${amendmentId}`
  );
};
export const deletePlanAmendment = (id, amendmentId) => {
  return apiInstance().delete(
    `${endPoints.plan.deletePlanAmendment}/${id}/${amendmentId}`
  );
};
export const getManageEligibleRule = (id) => {
  return apiInstance().get(`${endPoints.plan.getManageEligibleRule}/${id}`);
};
export const savePlanAmendmentEligibilty = (payload) => {
  return apiInstance().post(`${endPoints.plan.savePlanAmendment}`, payload);
};
export const getSourcesListForVesting = (id) => {
  return apiInstance().get(`${endPoints.plan.getSourcesListForVesting}/${id}`);
};
export const getFieldSchema = (formName) => {
  return apiInstance().get(`${endPoints.plan.getFieldSchema}/${formName}`);
};
